<script>
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
import 'slick-carousel/slick/slick.css'

export default {
  components: {
    Slick: () => import("vue-slick"),
  },
  props: {
    carouselList: {
      type: Array,
      default: () => {
        return [
          {
            src: "https://assets.codepen.io/1759070/service-2%402x.png",
            thumb: "https://assets.codepen.io/1759070/service-2%402x.png",
            caption: "title",
          },
          {
            src: "https://assets.codepen.io/1759070/service-2%402x.png",
            thumb: "https://assets.codepen.io/1759070/service-2%402x.png",
            caption: "title",
          },
          {
            src: "https://assets.codepen.io/1759070/service-2%402x.png",
            thumb: "https://assets.codepen.io/1759070/service-2%402x.png",
            caption: "title",
          },
        ]
      }
    },
  },
  data() {
    const DEFAULT_PAGE_COUNT = 1;

    return {
      pageCount: DEFAULT_PAGE_COUNT,
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        initialSlide: DEFAULT_PAGE_COUNT - 1,
        arrows: true,
        centerPadding: '10px',
        touchThreshold: 6,
        centerMode: false,
        dots: false,
        nextArrow: '<button type="button" class="slick-next"></button>',
        prevArrow: '<button type="button" class="slick-prev"></button>',
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              // dots: true,
            }
          },
        ],
      },
      /* gallery: [
       {
       src: "https://lipsum.app/id/2/800x600",
       thumb: "https://lipsum.app/id/2/80x80",
       caption: "",
       },
       {
       src: "https://lipsum.app/id/3/800x600",
       thumb: "https://lipsum.app/id/3/80x80",
       caption: "",
       },
       {
       src: "https://lipsum.app/id/4/800x600",
       thumb: "https://lipsum.app/id/4/80x80",
       caption: "",
       },
       ] */
    }
  },
  methods: {
    onSlideTo(index) {
      this.$refs.slick.goTo(index - 1)
    },
    onNext() {
      this.$refs.slick.next()
    },
    onPrev() {
      this.$refs.slick.prev()
    },
    onBeforeChange(event, slick, currentSlide, nextSlide) {
      this.pageCount = nextSlide + 1
    },
    openFancybox() {
      Fancybox.show(this.carouselList, {
        mainClass: 'isStyleBase',
        Toolbar: {
          display: [
            { id: "prev", position: "center" },
            { id: "counter", position: "center" },
            { id: "next", position: "center" },
            "close",
          ],
        },
        // Your options go here
      });

      Fancybox.getInstance().jumpTo(this.pageCount - 1);
    },
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.commentCarouselImage">
    <div class="commentCarouselImage__slickBox">
      <Slick
        ref="slick"
        :options="slickOptions"
        class="slick isStyleBase"
        :class="$style.carouselList"
        @beforeChange="onBeforeChange"
      >
        <div
          v-for="(carousel, index) in carouselList"
          :key="`carouseItem-${index}`"
          class="carouselList__item"
        >
          <div
            class="carouselList__image"
            :style="{ backgroundImage: `url('${ carousel.src }')` }"
          ></div>
        </div>
      </Slick>
      <BaseButton
        class="isStylePrimary isText2 commentCarouselImage__view"
        @click="openFancybox"
      >
        <i class="fal fa-eye"></i>
      </BaseButton>
    </div>
    <div
      v-if="carouselList.length > 1"
      :class="$style.blockList"
      class="row"
    >
      <div
        v-for="(carousel, index) in carouselList"
        :key="`carouseItem3-${index}`"
        class="blockList__item"
        :class="[carouselList.length < 5 ? 'col-3' : 'col', { isActive: index + 1 === pageCount }]"
        @click="onSlideTo(index + 1)"
      >
        <div
          class="blockList__image"
          :style="{ backgroundImage: `url('${ carousel.src }')` }"
        ></div>
      </div>
    </div>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.commentCarouselImage {
  :global {
    .commentCarouselImage {
      &__viewButton {
        position: relative;
      }

      &__view {
        position: absolute;
        top: 50%;
        left: 50%;
        font-size: 2rem;
        text-shadow: 0 0 30px #000;
        opacity: 0;
        transition: opacity 0.3s;
        transform: translate(-50%, -50%);
      }

      &__slickBox {
        position: relative;

        &:hover {
          .commentCarouselImage {
            &__view {
              opacity: 1;
            }
          }
        }
      }
    }
  }
}

.blockList {
  @include max-sm {
    margin-right: -0.25rem;
    margin-left: -0.25rem;
  }

  :global {
    .blockList {
      &__item {
        cursor: pointer;
        opacity: 1;
        transition: opacity 0.3s;

        @include max-sm {
          padding-right: 0.25rem;
          padding-left: 0.25rem;
        }

        &.isActive {
          opacity: 0.65;
        }
      }

      &__image {
        padding-top: 100%;
        background-color: $color-bg-default;
        background-position: center;
        background-size: cover;
        border: 2px solid #fff;
        transition: border 0.3s;

        &:hover {
          border-color: $color-primary;
        }

        &:active {
          border-color: transparent;
        }
      }
    }
  }
}

.carouselList {
  margin-bottom: 1rem;

  &:hover {
    :global {
      // stylelint-disable selector-class-pattern
      .slick-arrow {
        opacity: 1;
      }

      // stylelint-enable selector-class-pattern
    }
  }

  // stylelint-disable-next-line no-descending-specificity
  :global {
    .carouselList {
      &__item {
        @include unstyled;
      }

      &__image {
        padding-top: 60%;
        background-color: $color-bg-default;
        background-position: center;
        background-size: cover;
      }
    }

    // stylelint-disable selector-class-pattern, no-descending-specificity
    .slick-arrow {
      position: absolute;
      top: 50%;
      z-index: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 8rem;
      height: 100%;
      font-size: 0;
      pointer-events: auto;
      background: transparent;
      border: unset;
      opacity: 0;
      transition: opacity 0.3s;
      transform: translateY(-50%);
      appearance: none;

      @include max-md {
        width: 3rem
      }

      &:focus {
        outline: none;
      }

      &::before {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        font-family: $font-awesome;
        font-size: 1rem;
        color: #68757F;
        content: '\f054';
        background: rgba(#fff, 0.9);
        border-radius: 100%;

        @include max-md {
          width: 24px;
          height: 24px;
          font-size: 0.6rem;
        }
      }

      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: -1;
        content: '';
        opacity: 0;
        transition: opacity 0.3s;
      }

      &:hover {
        &::after {
          opacity: 1;
        }
      }

      &:active {
        &::after {
          opacity: 0;
        }
      }

      &.slick-next {
        right: 0;

        &::before {
          content: '\f054';
        }

        &::after {
          background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.05) 60%);
        }
      }

      &.slick-prev {
        left: 0;

        &::before {
          content: '\f053';
        }

        &::after {
          background: linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.05) 60%);
        }
      }
    }
    // stylelint-enable selector-class-pattern, no-descending-specificity
  }
}
</style>
